var _circle, _path, _path2, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#7CF8C4",
    fillOpacity: 0.19
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.334 25.7501C16.334 23.8645 16.334 22.9217 16.9198 22.3359C17.5056 21.7501 18.4484 21.7501 20.334 21.7501H29.6673C31.5529 21.7501 32.4957 21.7501 33.0815 22.3359C33.6673 22.9217 33.6673 23.8645 33.6673 25.7501V28.7501C33.6673 31.5785 33.6673 32.9928 32.7886 33.8714C31.91 34.7501 30.4957 34.7501 27.6673 34.7501H22.334C19.5056 34.7501 18.0913 34.7501 17.2127 33.8714C16.334 32.9928 16.334 31.5785 16.334 28.7501V25.7501Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8765 21.75L29.9605 21.0777C30.241 18.8334 29.2312 16.623 27.351 15.3659V15.3659C25.1124 13.8691 22.1494 14.0536 20.1137 15.8165L19.2272 16.5843",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.0007,
    cy: 28.25,
    rx: 2.16667,
    ry: 2.16667,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lockIcon.470e704aacfc396cac3f259360573220.svg";
export { ForwardRef as ReactComponent };